import _Vue from "vue";

export default {
  install(Vue: typeof _Vue) {
    Vue.mixin({
      beforeRouteEnter(to, from, next) {
        next((vm) => {
          vm.$prevRoute = from;
        });
      },
    });

    Vue.prototype.$prevRoute = null;
  },
};
